import { SELECTED_DAY_OPTIONS } from '@/const/termSelectOptions'
export default {
  /**
   * 比較期間がある期間条件フォーマット
   *
   * 日 / 週 / 月 どれが選択されているか、と開始・終了日を保持します。
   * 期間の種別が週や月であっても、最終的な開始・終了の日付で管理します。
   */
  get() {
    return {
      /**
       * 期間種別（日:d / 週:w / 月:m）
       */
      termType: 'w',
      /**
       * 基準
       */
      base: {
        /**
         * 開始日
         */
        dateFrom: undefined,
        /**
         * 終了日
         */
        dateTo: undefined,
        /**
         * ～から、～まで
         */
        weekType: 'COUNT_TO',
        /**
         * 日付選択か曜日選択か
         */
        selectType: 'date',
        /**
         * 選択した日付のリスト
         * [1, 11, 21]
         */
        selectedDates: [],
        /**
         * 選択した曜日のリスト
         * [0, 1, 2]
         */
        selectedDays: [],
      },
      /**
       * 比較
       */
      compare: {
        /**
         * 開始日
         */
        dateFrom: undefined,
        /**
         * 終了日
         */
        dateTo: undefined,
        /**
         * ～から、～まで
         */
        weekType: 'COUNT_TO',
        /**
         * 日付選択か曜日選択か
         */
        selectType: 'date',
        /**
         * 選択した日付のリスト
         * [1, 11, 21]
         */
        selectedDates: [],
        /**
         * 選択した曜日のリスト
         * [0, 1, 2]
         */
        selectedDays: [],
      },
      /**
       * 入力エラー
       */
      errors: [],
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(term) {
    const baseSelectedDaysSorted = [...SELECTED_DAY_OPTIONS]
      .filter(f => term.base.selectedDays.some(s => s === f.id))
      .sort((a, b) => a.order - b.order)
      .map(m => m.id)
    const compareSelectedDaysSorted = [...SELECTED_DAY_OPTIONS]
      .filter(f => term.compare.selectedDays.some(s => s === f.id))
      .sort((a, b) => a.order - b.order)
      .map(m => m.id)

    return {
      base: {
        termType: term.termType,
        dateFrom: term.base.dateFrom,
        dateTo: term.base.dateTo,
        selectType: term.base.selectType,
        selectedDates: term.base.selectedDates.sort((a, b) => a - b),
        selectedDays: baseSelectedDaysSorted,
      },
      compare: {
        termType: term.termType,
        dateFrom: term.compare.dateFrom,
        dateTo: term.compare.dateTo,
        selectType: term.compare.selectType,
        selectedDates: term.compare.selectedDates.sort((a, b) => a - b),
        selectedDays: compareSelectedDaysSorted,
      },
    }
  },
  /**
   * applyToに対してtermを適用する
   * 導入前に保存された条件にはweekTypeがなく、
   * 復元時にはundefinedなのでweekTypeにはデフォルトCOUNT_TOを入れる
   */
  applyPayload(applyTo, term) {
    // 基準/比較パターンに対して画面遷移することはないので、適用処理は必ず
    // このモデル形式をこのモデル形式に当てはめるだけ。
    applyTo.termType = term.termType
    applyTo.base.dateFrom = term.base.dateFrom
    applyTo.base.dateTo = term.base.dateTo
    applyTo.base.weekType = term.base.weekType || 'COUNT_TO'
    applyTo.base.selectType = term.base.selectType || 'date'
    applyTo.base.selectedDates = term.base.selectedDates || []
    applyTo.base.selectedDays = term.base.selectedDays || []
    applyTo.compare.dateFrom = term.compare.dateFrom
    applyTo.compare.dateTo = term.compare.dateTo
    applyTo.compare.weekType = term.compare.weekType || 'COUNT_TO'
    applyTo.compare.selectType = term.compare.selectType || 'date'
    applyTo.compare.selectedDates = term.compare.selectedDates || []
    applyTo.compare.selectedDays = term.compare.selectedDays || []
  },
}
